<ng-container *ngIf="productData.length > 0" (window:resize)="changeCarouselLimit()">
  <h3 *ngIf="isDevice; else other_content">{{ deviceSectionAEMContent?.accessories }}</h3>
  <ng-template #other_content>
    <h3>{{ deviceSectionAEMContent?.relatedAccessories }}</h3>
  </ng-template>
  <div *ngIf="!isPlanFirst && !useRouteParam" class="m-t-xl">
    <h3 class="inline-block w-50">{{ deviceSectionAEMContent?.accessories }}</h3>
    <p class="m-t-lg">{{ deviceSectionAEMContent?.recommended }}</p>
  </div>
  <div *ngIf="isPlanFirst" class="m-t-xl">
    <hr class="divider m-t-lg" />
    <div class="row">
      <div class="col-12 m-t-xl">
        <h4 class="inline-block w-50">{{ deviceSectionAEMContent?.selectDevice }}</h4>
        <a
          class="inline-block lead pull-right"
          [routerLink]="[routerURL]"
          [queryParams]="{ allowEdit: true }"
          id="cta-default-706"
          >{{ deviceSectionAEMContent?.seeAllCompatibleDevices }}</a
        >
      </div>
    </div>
  </div>
  <div class="row" *ngIf="accessoriesAlert && productSelectorAddedAccessory">
    <div class="col-12 m-t-lg">
      <p class="alert-text">
        <i class="fa fa-flag def alert-icon"></i> Any previously selected accessories in your cart
        will not be reflected below.
      </p>
    </div>
  </div>
  <div class="row" *ngIf="showAccessoryExceedLimitMessage">
    <div class="col-12 m-t-lg">
      <p class="alert-text">
        <i class="fa fa-flag def alert-icon"></i> Your selection has been deselected as you can only
        checkout with 5 of the same accessory.
      </p>
    </div>
  </div>
  <div id="gallery">
    <div class="accessories gallery row m-t-lg">
      <div class="gallery-thumbs col-12 col-sm-10 offset-sm-1">
        <!-- Left Arrow -->
        <a
          class="left-arrow"
          attr.aria-label="{{ nextButton }}"
          href="javascript:void(0);"
          (click)="moveLeft()"
          [ngClass]="{ disable: !leftActive }"
          id="cta-next-button-7"
        >
          <i class="fa fa-angle-left"></i
        ></a>
        <!-- Item List Carousel strip -->
        <div class="thumbs-container" #thumbsContainer>
          <ul class="thumbs-strip" #thumbsStrip>
            <ng-container *ngFor="let item of productData; let i = index">
              <li
                class="thumb-item thumb-item-product text-center"
                #thumbItem
                [style.width]="width"
                [ngClass]="{ selected: i + 1 == thumbSelected }"
                (click)="handleClick(item)"
              >
                <a
                  href="javascript:void(0);"
                  tabindex="{{ i >= carouselRIdx ? '0' : '-1' }}"
                  *ngIf="i <= 2"
                >
                  <img
                    class="inline-block gallery-image-absolute-disabled"
                    [ngClass]="{
                      small: itemsToDisplay >= 4,
                      'browse-image': item?.type === deviceConstant,
                    }"
                    [src]="item?.itemDetails[0]?.imageUrl"
                    [alt]=""
                  />
                </a>
                <a
                  href="javascript:void(0);"
                  class="m-r-xl"
                  tabindex="{{ i <= carouselRIdx + 2 && i >= carouselRIdx - 2 ? '0' : '-1' }}"
                  *ngIf="i > 2"
                >
                  <img
                    class="inline-block gallery-image-absolute-disabled"
                    [ngClass]="{
                      small: itemsToDisplay >= 4,
                      'browse-image': item?.type === deviceConstant,
                    }"
                    [src]="item?.itemDetails[0]?.imageUrl"
                    [alt]=""
                  />
                </a>
                <p class="small m-t-md">{{ item?.familyName }}&nbsp;</p>
                <ng-container *ngIf="!useRouteParam && !isPlanFirst">
                  <p class="xsmall m-t-sm" *ngIf="deviceSectionAEMContent">
                    <label class="inline-block m-t-sm">
                      <tmo-checkbox
                        tabindex="{{ i >= carouselRIdx ? '0' : '-1' }}"
                        *ngIf="i <= 2"
                        [(ngModel)]="item.isSelected"
                        (click)="onAccessoryCheckBoxClick(item, $event)"
                        [id]="'type' + item.familyName"
                        [name]="'type_' + item.familyName"
                      >
                      </tmo-checkbox>
                    </label>
                    <label class="inline-block m-t-sm">
                      <tmo-checkbox
                        tabindex="{{ i <= carouselRIdx + 2 && i >= carouselRIdx - 2 ? '0' : '-1' }}"
                        *ngIf="i > 2"
                        [(ngModel)]="item.isSelected"
                        (click)="onAccessoryCheckBoxClick(item, $event)"
                        [id]="'type' + item.familyName"
                        [name]="'type_' + item.familyName"
                      >
                      </tmo-checkbox>
                    </label></p
                ></ng-container>
              </li>
            </ng-container>
          </ul>
        </div>
        <!-- Right Arrow -->
        <a
          class="right-arrow"
          attr.aria-label="{{ nextButton }}"
          href="javascript:void(0);"
          (click)="moveRight()"
          [ngClass]="{ disable: !rightActive }"
          id="cta-next-button-8"
        >
          <i class="fa fa-angle-right"></i
        ></a>
      </div>
    </div>
  </div>
  <div class="row m-t-lg" *ngIf="isProductSelector && isEipEligible">
    <div class="col-12">
      <p class="legal text-center">{{ deviceSectionAEMContent?.remainingBalanceDueForEip }}</p>
    </div>
  </div>
  <div class="row">
    <div *ngIf="!isPlanFirst && !useRouteParam && !isProductSelector" class="col-12 m-t-lg">
      <p>
        <a
          href="javascript:void(0);"
          (click)="handleClick('browse-accessories')"
          id="cta-default-707"
          >{{ deviceSectionAEMContent?.seeAllAccessories }}</a
        >
      </p>
    </div>
  </div>
  <tmo-spinner [setDelay]="!showSpinner"></tmo-spinner>
</ng-container>
